import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import CustomizePage from "@/pages/CustomizePage";
import CartPage from "@/pages/CartPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import ShippingPage from "@/pages/ShippingPage";
import CheckoutPage from "@/pages/CheckoutPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import AdminPage from "@/pages/AdminPage";
import EventLandingPage from "@/pages/EventLandingPage";
import PromoLanding from "@/pages/PromoLanding";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/customize/:productId" element={<CustomizePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/track" element={<TrackOrderPage />} />
        <Route path="/shipping" element={<ShippingPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/event/:eventId" element={<EventLandingPage />} />
        <Route path="/promo/:code" element={<PromoLanding />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
